import * as React from 'react'
import {connect} from 'react-redux'
import {ApplicationState, ConnectedReduxProps} from '@reducers/index'
import {Person} from '@models/person'
import {deleteRequest, fetchRequest} from '@actions/people'
import PeoplesTable from "@components/people/Table";
import TableRenderer from "@hocs/TableRenderer";
import {getPeopleList} from "@reducers/people";
import {FormattedMessage} from 'react-intl';
import PersonForm from "@components/people/Form";
import {Button, Card, Col, Input, Row, Modal} from "antd";
import SearchPeopleComponent from "@components/people/Search";
import {NavLink} from "react-router-dom";

interface PropsFromState {
  loading: boolean
  data: Person[]
  errors?: string,
  count: number
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest
  deleteRequest: typeof deleteRequest
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps


class PeopleIndexPage extends React.Component<AllProps> {
  
  deletePeople = (item: Person): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    })
  };
  
  render() {
    const {loading, data, search, currentPage} = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <NavLink to={`/people/create`}>
            <Button type={'primary'}><FormattedMessage id="app.create_new_person"
                                                       defaultMessage={`Create Person`}/></Button>
          </NavLink>
        </div>
        <div className={'page-table-wrapper'}>
          <Card className={`page-table-header`} bordered={false}>
            <SearchPeopleComponent search={search}/>
          </Card>
          
          <PeoplesTable data={data}
                        currentPage={currentPage}
                        rowKey={record => record.id}
                        deleteFn={this.deletePeople}
                        loading={loading}/>
        </div>
      
      </div>
    )
  }
}

const mapStateToProps = ({people}: ApplicationState) => ({
  loading: people.loading,
  data: getPeopleList(people),
  count: people.count,
});

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(TableRenderer(PeopleIndexPage));

